module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "faultOffer"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-row', [_c('el-col', [_c('ul', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('span', {
    staticClass: "headerSpan"
  }, [_vm._v("品牌")]), _vm._v(" "), _vm._l((_vm.brandLists), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "fl listPart",
      class: {
        active: _vm.activeBrandIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.selectBrand(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.brandName))])
  })], 2), _vm._v(" "), _c('ul', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('span', {
    staticClass: "headerSpan"
  }, [_vm._v("品类")]), _vm._v(" "), _vm._l((_vm.categoryLists), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "fl listPart",
      class: {
        active: _vm.activeCategoryIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.selectCategory(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.categoryName))])
  })], 2)])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [(_vm.faultAuth.saveTable) ? _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showText),
      expression: "!showText"
    }],
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "type": "success",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.exitTable()
      }
    }
  }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showText),
      expression: "showText"
    }],
    staticStyle: {
      "margin-left": "0px",
      "margin-bottom": "15px"
    },
    attrs: {
      "type": "success",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.saveTable()
      }
    }
  }, [_vm._v("\n          保存\n        ")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.tableData3
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "故障",
      "align": "right"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "modelName",
      "label": "型号",
      "width": "120"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.testData), function(item, index) {
    return _c('el-table-column', {
      key: index,
      attrs: {
        "align": "center",
        "label": item.faultTypesName
      }
    }, _vm._l((item.faultSubclasses), function(m, j) {
      return _c('el-table-column', {
        key: j,
        attrs: {
          "label": m.faultSubclassName,
          "align": "center"
        },
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(scope) {
            return [(scope.row.faultSubclassId !== m.faultSubclassId || scope.row.price == null) ? _c('span', [_vm._v("-")]) : (_vm.showText == false && scope.row.price !== null) ? _c('span', [_vm._v(_vm._s(scope.row.price) + " ")]) : (_vm.showText == true && scope.row.price !== null) ? _c('el-input', {
              model: {
                value: (scope.row.price),
                callback: function($$v) {
                  _vm.$set(scope.row, "price", (typeof $$v === 'string' ? $$v.trim() : $$v))
                },
                expression: "scope.row.price"
              }
            }) : _vm._e()]
          }
        }], null, true)
      })
    }), 1)
  })], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-ad16f010","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/basicSetting/faultOffer.vue
// module id = 1743
// module chunks = 0